/* esm.sh - lit-html@2.8.0/directives/if-defined */
import{nothing as o}from"../lit-html.mjs";var i=n=>n??o;export{i as ifDefined};
/*! Bundled license information:

lit-html/directives/if-defined.js:
  (**
   * @license
   * Copyright 2018 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
//# sourceMappingURL=if-defined.mjs.map